"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.checkIsStringArray = exports.MultipleSelectFieldLogic = void 0;
const difference_1 = __importDefault(require("lodash-es/difference"));
const sortBy_1 = __importDefault(require("lodash-es/sortBy"));
const react_fast_compare_1 = __importDefault(require("react-fast-compare"));
const clipboard_1 = require("../../clipboard");
const clipboard_2 = require("../../clipboard/clipboard");
const types_1 = require("@smartsuite/types");
const field_logic_1 = require("../../field-type-registry/field-logic");
const comparisons_1 = require("../../comparisons/comparisons");
const fields_1 = require("../../utils/fields");
const migration_1 = require("../../utils/migration");
const intl_1 = require("../../locale/intl");
const migrations_1 = require("../../migrations");
const migrations_2 = require("../../migrations/migrations");
const multiple_select_fieldtype_1 = require("../../safe-field-value/multiple-select-fields/multiple-select.fieldtype");
const utils_1 = require("../../sort/utils");
const texts_1 = require("../../texts");
const color_1 = require("../../utils/color");
const filter_1 = require("../../utils/filter");
const yes_no_field_1 = require("../yes-no-field");
const validation_1 = require("../../validation/validation");
const choice_fields_1 = require("../../utils/choice-fields");
const bulk_update_1 = require("../../utils/bulk-update");
class MultipleSelectFieldLogic extends field_logic_1.BaseFieldTypeLogic {
    constructor() {
        super(...arguments);
        this.name = "multipleselectfield";
        this.label = (0, intl_1.$t)(texts_1.multipleSelectFieldText.multiple_select);
        this.icon = "multiple-select";
        this.iconColor = "#3EAC40";
        this.placeholder = (0, intl_1.$t)(texts_1.multipleSelectFieldText.select_from_list);
        this.searchSynonyms = [(0, intl_1.$t)(texts_1.multipleSelectFieldText.list)];
        this.choiceMaxLength = 400;
        // @ts-expect-error: Need to resolve
        this.comparisons = {
            is_empty: comparisons_1.isEmptyList,
            is_not_empty: comparisons_1.isNotEmptyList,
            has_all_of: comparisons_1.hasAllOf,
            has_any_of: comparisons_1.hasAnyOf,
            is_exactly: comparisons_1.isExactly,
            has_none_of: comparisons_1.hasNoneOf,
        };
        this.fieldValueGetter = new multiple_select_fieldtype_1.MultipleSelectFieldValueGetter();
        this.clipboardPasteRules = {
            firstcreatedfield: withOptionCreating(clipboard_2.clipboardCreatedUpdatedToMultiple),
            lastupdatedfield: withOptionCreating(clipboard_2.clipboardCreatedUpdatedToMultiple),
            linkedrecordfield: withOptionCreating(clipboard_2.clipboardReferenceFieldToMultipleSelectField),
            yesnofield: withOptionCreating(clipboard_1.clipboardTextToChoices),
            multipleselectfield: withOptionCreating(clipboard_2.clipboardMultipleSelectToSelf),
            singleselectfield: withOptionCreating(clipboard_2.clipboardSingleSelectToMultipleSelect),
            userfield: withOptionCreating(clipboard_2.clipboardMemberToMultipleSelect),
            emailfield: withOptionCreating(clipboard_2.clipboardEmailToMultiSelect),
            statusfield: withOptionCreating(clipboard_2.clipboardStatusToMultiSelect),
            textfield: withOptionCreating(clipboard_1.clipboardTextToChoices),
            recordtitlefield: withOptionCreating(clipboard_1.clipboardTextToChoices),
            textareafield: withOptionCreating(clipboard_1.clipboardTextToChoices),
            richtextareafield: withOptionCreating(clipboard_1.clipboardTextToChoices),
            tagsfield: withOptionCreating(clipboard_2.clipboardTagToMultipleSelect),
            fullnamefield: withOptionCreating(clipboard_2.clipboardFullNameToMultiple),
            unknownfield: withOptionCreating(clipboard_1.clipboardTextToChoices),
        };
        this.getColoredChoices = (field) => {
            var _a;
            return (0, color_1.getColoredChoices)((_a = field.params.choices) !== null && _a !== void 0 ? _a : []);
        };
    }
    get validators() {
        const uniqueValidator = (0, validation_1.uniqueRecordFieldValueWithContext)({
            checkUniqueness: this.appRecordsService.checkUniqueness.bind(this.appRecordsService),
        });
        return {
            required: validation_1.required,
            unique: uniqueValidator,
            requiredDescriptionForOtherValue: validation_1.requiredDescriptionForOtherValue,
        };
    }
    getCssClass(field) {
        if (field.params.control_type === "radiobutton") {
            return "record-group--poll";
        }
        return "";
    }
    sortKey(fieldValue, field) {
        if (!Array.isArray(fieldValue)) {
            return [];
        }
        const result = [];
        for (let i = 0; i < fieldValue.length; i++) {
            const choiceId = fieldValue[i];
            const choice = (0, fields_1.getFieldChoiceByValue)(field, choiceId);
            const order = (0, utils_1.getListFieldOrderValue)(choice);
            result.push(order);
        }
        return result;
    }
    useNaturalSorting(field, fieldValue, isGroupByRule) {
        return false;
    }
    groupByKey(fieldValue, field) {
        return this.sortKey(fieldValue, field).join(",");
    }
    getGroupValues(fieldValue) {
        if (!Array.isArray(fieldValue) || !fieldValue.length) {
            return [[]];
        }
        return fieldValue
            .filter(filter_1.filterUniqueValues)
            .map((valueItem) => [valueItem]);
    }
    getInlineEditRules(field) {
        return {
            ...super.getInlineEditRules(field),
            saveKeys: types_1.navigationKeys,
            editOnStartTyping: false,
            switchToInputControl: "OnCellSelect",
            enablePasteEventInEditMode: true,
            enableCopyEventInEditMode: true,
            editorWidth: "0",
            inputControlEditMode: "OnShow",
            cellPresenceEventMode: "OnModalOpen",
            canUnselectCell: (value, isDirty, isValid, fieldsMetadata) => {
                const metadata = fieldsMetadata === null || fieldsMetadata === void 0 ? void 0 : fieldsMetadata[field.slug];
                const isFieldMetadataValid = metadata
                    ? this.isFieldMetadataValid(metadata)
                    : true;
                return (super
                    .getInlineEditRules(field)
                    .canUnselectCell(value, isDirty, isValid, fieldsMetadata) &&
                    isFieldMetadataValid);
            },
            needUseDefaultValue: (value, isDirty) => {
                const isNeedUseDefaultValue = (0, fields_1.needUseDefaultFieldValue)(field, value);
                return isDirty && isNeedUseDefaultValue;
            },
            spaceKeyOpensRecordModal: () => true,
        };
    }
    getEmptyValue() {
        return [];
    }
    migrateField(fieldTo, fieldFrom, applicationId) {
        var _a;
        let migratedField;
        if (fieldFrom.field_type === "statusfield") {
            migratedField = (0, migrations_1.migrateStatusFieldToListField)(fieldTo, fieldFrom);
        }
        else if (fieldFrom.field_type === "yesnofield") {
            migratedField = (0, yes_no_field_1.yesNoFieldToListField)(fieldTo, fieldFrom);
        }
        else if (fieldFrom.field_type === "singleselectfield") {
            migratedField = (0, migrations_1.migrateSingleSelectFieldToMultipleSelectField)(fieldTo, fieldFrom);
        }
        else if (fieldFrom.field_type === "tagsfield") {
            migratedField = (0, migrations_2.migrateTagsFieldToListField)(fieldTo, fieldFrom, applicationId);
        }
        else {
            migratedField = (0, migrations_2.migrateBaseField)(fieldTo, fieldFrom);
        }
        const displayFormats = [
            "importance",
            "colored_pill",
            "text_only",
        ];
        return (0, migration_1.migrateDisplayFormat)(migratedField, displayFormats, (_a = fieldTo.params.display_format) !== null && _a !== void 0 ? _a : "");
    }
    getFilterComponentData(field, comparison) {
        return {
            ...super.getFilterComponentData(field, comparison),
            choices: field.params.choices,
        };
    }
    formatActivityRecordChangeValues(previousValue, currentValue, _extraData, field) {
        if (this.isValueEmpty(previousValue, field) ||
            this.isValueEmpty(currentValue, field)) {
            return { previousValue, currentValue };
        }
        const removedValues = (0, difference_1.default)(previousValue, currentValue);
        const addedValues = (0, difference_1.default)(currentValue, previousValue);
        return { previousValue: removedValues, currentValue: addedValues };
    }
    isValueEqual(fieldValue1, fieldValue2) {
        return (0, react_fast_compare_1.default)((0, sortBy_1.default)(fieldValue1), (0, sortBy_1.default)(fieldValue2));
    }
    isGroupHighlighted(_field) {
        return true;
    }
    getChoiceByRecordValue(record, field) {
        var _a, _b;
        const recordValue = (0, fields_1.getValueFromRecordByField)(record, field);
        if ((0, exports.checkIsStringArray)(recordValue)) {
            return ((_b = (_a = field.params.choices) === null || _a === void 0 ? void 0 : _a.find(({ value }) => recordValue[0] === value)) !== null && _b !== void 0 ? _b : null);
        }
        return null;
    }
    replaceValue(field, record, sourceValue = [], targetValue = [], _userPreferences) {
        return (0, fields_1.replaceValueInList)(field, record, sourceValue, targetValue);
    }
    getLinkedRecordFieldSmartWidth(_field) {
        return {
            defaultWidht: 170,
            minWidth: 90,
        };
    }
    filterToRecordValue(filterValue, comparison, field) {
        var _a;
        const validValues = (_a = field.params.choices) === null || _a === void 0 ? void 0 : _a.map(({ value }) => value);
        const validComparison = ["is_exactly", "has_all_of"];
        if (Array.isArray(filterValue) &&
            validComparison.includes(comparison) &&
            filterValue.every((val) => validValues === null || validValues === void 0 ? void 0 : validValues.includes(val))) {
            return filterValue;
        }
        throw new types_1.FilterToRecordValueConversionError(field, filterValue, comparison);
    }
    getContentSize(fieldValue, field, userPreferences, record, font) {
        const { display_format } = field.params;
        const hasDot = display_format === "importance";
        const isTextOnly = display_format === "text_only";
        const pillPadding = isTextOnly ? 0 : 20 * fieldValue.length;
        const pillDot = hasDot ? 18 : 0;
        const size = super.getContentSize(fieldValue, field, userPreferences, record, font);
        return size + pillPadding + pillDot;
    }
    /**
     * Applies a bulk update to a field value.
     */
    applyBulkUpdate(field, value, update) {
        return (0, bulk_update_1.applyBulkUpdateToPrimitiveArray)(value, update);
    }
    isFieldMetadataValid(newValue) {
        if (!newValue || typeof newValue !== "object") {
            return false;
        }
        const metadata = newValue;
        return ("description" in metadata &&
            typeof metadata.description === "string" &&
            metadata.description.trim() !== "");
    }
    processSearch(searchTerm, fieldValue, field, userPreferences, record) {
        if (super.processSearch(searchTerm, fieldValue, field, userPreferences, record)) {
            return true;
        }
        return this.processSearchInFieldMetadata(searchTerm, field, record);
    }
    processSearchInFieldMetadata(searchTerm, field, record) {
        const preparedTerm = this.prepareSearchTerm(searchTerm);
        const metadata = this.getFieldMetadata(field, record);
        if (!preparedTerm || !(metadata === null || metadata === void 0 ? void 0 : metadata.description))
            return false;
        return metadata.description.toLowerCase().includes(preparedTerm);
    }
}
exports.MultipleSelectFieldLogic = MultipleSelectFieldLogic;
/**
 * Guard function that checks that value is a list of strings.
 *
 * @param value - designed to be used with record values.
 * @returns If true, the value is type-casted.
 */
const checkIsStringArray = (value) => {
    return (Array.isArray(value) &&
        value.every((element) => typeof element === "string"));
};
exports.checkIsStringArray = checkIsStringArray;
const withOptionCreating = (fn) => {
    return async (...args) => {
        var _a, _b;
        const [clipboardValue, srcField, targetField, userPreferences, currentValue, extra,] = args;
        const choiceValue = fn(clipboardValue, srcField, targetField, userPreferences, currentValue, extra);
        if (((extra === null || extra === void 0 ? void 0 : extra.canMigrateField) || targetField.params.new_choices_allowed) &&
            !(0, react_fast_compare_1.default)(choiceValue, currentValue)) {
            const newChoices = (0, choice_fields_1.getChoicesWithParams)(choiceValue.filter((choice) => {
                var _a;
                return !((_a = targetField.params.choices) === null || _a === void 0 ? void 0 : _a.map(({ value }) => value).includes(choice));
            }), srcField);
            const field = newChoices.length
                ? await ((_a = extra === null || extra === void 0 ? void 0 : extra.fieldsService) === null || _a === void 0 ? void 0 : _a.createFieldChoices(extra.applicationId, targetField, (0, choice_fields_1.getChoicesWithParams)(choiceValue.filter((choice) => {
                    var _a;
                    return !((_a = targetField.params.choices) === null || _a === void 0 ? void 0 : _a.map(({ value }) => value).includes(choice));
                }), srcField)))
                : targetField;
            return await Promise.resolve((_b = field.params.choices) === null || _b === void 0 ? void 0 : _b.filter(({ label, value }) => choiceValue.includes(label) ||
                choiceValue.includes(value)).map(({ value }) => value));
        }
        return await Promise.resolve(choiceValue.filter((choice) => { var _a; return (_a = targetField.params.choices) === null || _a === void 0 ? void 0 : _a.map(({ value }) => value).includes(choice); }));
    };
};
